import { InternalGrid, Title } from '@paygreen/paygreen-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { CardClassic } from '../../../components';
import { convertCarbonValue, IsMobile } from '../../../utils/tools';
import ContributionDetailCard from './ContributionDetailCard';

const ContributionsGlobalCard = ({ t, isLoading, reportsData }) => (
    <CardClassic
        blockWidth="none"
        paddingLateral="sm"
        paddingTop="sm"
        paddingBottom="sm"
        isShadowWab={true}
        radiusSize="sm"
    >
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="100%"
            alignItems="stretch"
            justifyItems="stretch"
            childrenMarginTop="xs"
        >
            <div>
                <Title
                    htmlTag="h3"
                    colorWab="grey30"
                    marginBottom="xs"
                    textSize="md"
                >
                    {t('contributions.globalView.globalCard.contributedTitle')}
                </Title>

                <InternalGrid
                    displayType="grid"
                    gridTemplateColumns={IsMobile() ? '1OO%' : '1fr 1fr 1fr'}
                    gridGap="md"
                    alignItems="stretch"
                    justifyItems="stretch"
                >
                    <ContributionDetailCard
                        isLoading={isLoading}
                        cardTitle={t(
                            'contributions.globalView.globalCard.bySupplierTitle',
                        )}
                        contributionData={convertCarbonValue(
                            reportsData?.carbonOffsetByThirdParty,
                            true,
                        )}
                    />
                    <ContributionDetailCard
                        isLoading={isLoading}
                        cardTitle={t(
                            'contributions.globalView.globalCard.byCustomerTitle',
                        )}
                        contributionData={convertCarbonValue(
                            reportsData?.carbonOffsetFromConsumer,
                            true,
                        )}
                    />

                    <ContributionDetailCard
                        isLoading={isLoading}
                        colorStatus="success"
                        cardTitle={t(
                            'contributions.globalView.globalCard.byYouTitle',
                        )}
                        contributionData={convertCarbonValue(
                            reportsData?.carbonOffset,
                            true,
                        )}
                    />
                </InternalGrid>
            </div>
        </InternalGrid>
    </CardClassic>
);

ContributionsGlobalCard.propTypes = {
    reportsData: PropTypes.object,
    isLoading: PropTypes.bool,
};

ContributionsGlobalCard.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(ContributionsGlobalCard);
